import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { DomainRichPlacementMultiAnchorConfigurationDTO } from '../types/domainRichPlacementMultianchorConfigurationDTO'

type Props = {
  ability: Ability
}

export const DOMAIN_RICH_PLACEMENT_MULTI_ANCHOR_CONFIGURATION_FRAGMENT = ({
  ability,
}: Props): TypedDocumentNode<DomainRichPlacementMultiAnchorConfigurationDTO> => gql`
  fragment DomainRichPlacementMultiAnchorConfigurationFragment on DomainRichPlacementMultianchorConfiguration {
    autoGenerateDivIdsEnabled
    counterStyle
    customVariableName
    customVariableTriggerEnabled
    customVariableValue
    customizeApperanceEnabled
    customizeBasicSettingsEnabled
    customStyling
    displayAfterUserInteractionEnabled
    ${permitFields<DomainRichPlacementMultiAnchorConfigurationDTO>({
      frequencyCappingEnabled: ability.can('read', 'DomainField-frequencyCapping'),
      impressionLimit: ability.can('read', 'DomainField-frequencyCapping'),
      timeWindow: ability.can('read', 'DomainField-frequencyCapping'),
    })}
    fullWidthModeEnabled
    enabled
    matchType
    path
    pathTriggerEnabled
    showCloseButtonEnabled
    singleAdViewTime
    adUnits {
      id
    }
  }
`
